import { useEffect, useState } from "react";
import axios from "axios";
import type { Feed } from "../types/rss";

interface FetchFeedResponse {
  feedData: Feed;
}

export const useRssFetch = (url: string): Feed => {
  const [data, setData] = useState<Feed>({});

  useEffect(() => {
    axios
      .post<FetchFeedResponse>("/.netlify/functions/fetch-feed", {
        url
      })
      .then(res => setData(res.data.feedData))
      .catch(err => console.log(err));
  }, [url]);

  return data;
};
